const STORAGE_KEY = "intentsify.return-path";
const MAX_LENGTH = 512;
const PROTOCOL_RELATIVE = /^\/[/\\]/;
const AUTH_PATH = /^\/(auth|oauth)(\/|$)/;

const isSafeReturnPath = (path: string): boolean =>
  path.startsWith("/") &&
  path.length <= MAX_LENGTH &&
  !PROTOCOL_RELATIVE.test(path) &&
  !AUTH_PATH.test(path);

const saveReturnPath = (path: string): void => {
  if (!isSafeReturnPath(path)) {
    return;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch (err) {
    console.log("Session storeage is unavailable");
  }
};

const consumeReturnPath = (): string | undefined => {
  let path;
  try {
    path = sessionStorage.getItem(STORAGE_KEY) ?? undefined;
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.log("Session storeage is unavailable");
  }

  return path && isSafeReturnPath(path) ? path : undefined;
};

export { consumeReturnPath, saveReturnPath };
